import { Box, DashboardModule } from '@domain-group/suit-theme'

import useOrderItem from '@hooks/useOrderItem'

import type { OrderItemModel } from '@models/types'
import type { ValidateOrderItemError } from '@functions/orderItem'

import type { UseOrderApprovalPayload } from '@modals/ApproveOrderModal/hooks/useOrderApproval'

import Artwork from './Artwork'
import Header from './Header'
import Task from './Task'

interface OrderItemProps {
  errors: ValidateOrderItemError[],
  orderItem: OrderItemModel,
  orderApprovalPayload: UseOrderApprovalPayload,
}

const OrderItem = (props: OrderItemProps) => {
  const {
    errors,
    orderApprovalPayload,
    orderItem,
  } = props

  const orderItemPayload = useOrderItem(orderItem)
  const {
    callbacks: { manageOrderItem },
    filteredOrderItemTasks,
    requiredItems,
    service,
  } = orderItemPayload

  return (
    <DashboardModule
      customHeader={(
        <Header
          callbacks={{ manageOrderItem }}
          orderItem={orderItem}
          // @ts-expect-error TS2739
          service={service}
        />
      )}
    >
      <Box flexDirection="column">
        {requiredItems.artwork && (
          <Artwork
            errors={errors.filter(error => error.filterType === 'artwork')}
            orderApprovalPayload={orderApprovalPayload}
            orderItemPayload={orderItemPayload}
          />
        )}

        {requiredItems.orderItemTask && filteredOrderItemTasks.map(orderItemTask => (
          <Task
            errors={errors.filter(error => error.filterType === 'task')}
            key={orderItemTask.id}
            orderItemTask={orderItemTask}
          />
        ))}
      </Box>
    </DashboardModule>
  )
}

export default OrderItem
